/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnaliticasModelDto } from '../../models/analiticas-model-dto';

export interface AnaliticasControllerObtenerAnaliticas$Params {

/**
 * Número máximo de analíticas a devolver
 */
  limit?: number;

/**
 * Paginación de los resultados
 */
  page?: number;
}

export function analiticasControllerObtenerAnaliticas(http: HttpClient, rootUrl: string, params?: AnaliticasControllerObtenerAnaliticas$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AnaliticasModelDto>>> {
  const rb = new RequestBuilder(rootUrl, analiticasControllerObtenerAnaliticas.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('page', params.page, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AnaliticasModelDto>>;
    })
  );
}

analiticasControllerObtenerAnaliticas.PATH = '/api/paciente-analiticas/obtener-analiticas';
